import {Component, Input, OnInit} from '@angular/core'
import {DomSanitizer} from '@angular/platform-browser'

@Component({
  selector: 'dmmp-detail-program-desc-bullets',
  templateUrl: './detail-program-desc-bullets.component.html'
})
export class DetailProgramDescBulletsComponent implements OnInit {
  @Input() identifier
  @Input() data
  active = 0

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnInit() {}

  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url)
  }
}
